var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPowerAutomate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4303_1230)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_4303_1230)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M52.5093 3C55.3657 3 58.0858 4.22148 59.9834 6.35636L82.6577 31.8649C88.9106 38.8995 85.0005 50.0661 75.7251 51.6632L21.5 61L28.2997 53.3134C30.9819 50.2813 30.9765 45.7235 28.287 42.6979L7.79435 19.6436C2.06189 13.1946 6.63995 3 15.2684 3H52.5093Z",
    fill: "url(#paint0_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2684 93C6.63995 93 2.0619 82.8054 7.79436 76.3563L59.0945 18.6436C62.4624 14.8548 62.4624 9.14522 59.0945 5.35636L57 3L91.0945 41.3564C94.4624 45.1453 94.4624 50.8548 91.0945 54.6437L59.9834 89.6436C58.0858 91.7785 55.3657 93 52.5093 93H15.2684Z",
    fill: "url(#paint1_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.2684 93C6.63995 93 2.0619 82.8054 7.79436 76.3563L59.0945 18.6436C62.4624 14.8548 62.4624 9.14522 59.0945 5.35636L57 3L91.0945 41.3564C94.4624 45.1453 94.4624 50.8548 91.0945 54.6437L59.9834 89.6436C58.0858 91.7785 55.3657 93 52.5093 93H15.2684Z",
    fill: "url(#paint2_linear_4303_1230)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.3611 93C33.184 93 30.4371 86.8833 33.8766 83.0139L75.0945 36.6436C78.4624 32.8548 78.4624 27.1452 75.0945 23.3563L71 18.75L91.0945 41.3563C94.4624 45.1452 94.4624 50.8547 91.0946 54.6436L59.9834 89.6437C58.0858 91.7785 55.3657 93 52.5093 93H38.3611Z",
    fill: "url(#paint3_linear_4303_1230)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4303_1230",
    x1: 48,
    y1: 31.5,
    x2: 14,
    y2: -2.50001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#102784"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.274053,
    stopColor: "#1B44B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4303_1230",
    x1: 76.5,
    y1: 25,
    x2: 11.5,
    y2: 91.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FAFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177827,
    stopColor: "#4894FE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2764E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4303_1230",
    x1: 28.5,
    y1: 72,
    x2: 38.5,
    y2: 83.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2764E7",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2052CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_4303_1230",
    x1: 89,
    y1: 38.5,
    x2: 43,
    y2: 90.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CE0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.211723,
    stopColor: "#66C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#58AAFE"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4303_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_4303_1230"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPowerAutomate);
export default __webpack_public_path__ + "static/media/power-automate.1fc4db1cf716c33bfbb2486255f6f810.svg";
export { ForwardRef as ReactComponent };